<app-stages [stages]='stages' currentStage='Dane zajęcia'></app-stages>
<br>
@if (!pending() && !loading()) {
  <form novalidate [formGroup]="form" (ngSubmit)="submitAndGoNext()">
    <div class="row">
      <div class="col-12">
        <app-occupation-of-lane-placement-construction-objects-form
          [serviceId]="serviceType()?.uuid || null"
          [form]='form'>
        </app-occupation-of-lane-placement-construction-objects-form>
      </div>
    </div>
    <div class='form-actions'>
      <button
        type='button'
        class='btn btn-secondary'
        (click)='onCancel()'>
        <span>
          Wstecz
        </span>
      </button>
      <button
        [disabled]='pending()'
        type='submit'
        class='btn btn-primary'>
        <span>Zapisz i przejdź dalej</span>
      </button>
    </div>
  </form>
  <br>
}
@if (pending()) {
  <app-spinner>
    Poczekaj trwa zapisywania danych...
  </app-spinner>
}
@if (loading()) {
  <app-spinner>
    Poczekaj trwa ładowanie danych...
  </app-spinner>
}
